<template>

  <v-container fluid class="mt-0 pt-0 page page-receiver-order-info">

    <!-- (data loading spinner) -->
    <v-container class="d-flex flex-column align-center justify-center" v-if="isDataLoading">
      <v-progress-circular indeterminate :size="50" style="margin-bottom:30px" color="primary" />
    </v-container>

    <v-container fluid class="px-0" v-else-if="order">

      <!-- Breadcrumb & Actions -->
      <v-row class="mt-4 mb-10">
        <v-col sm="8" class="d-flex align-center justify-start page-breadcrumb-new">
          <!-- (breadcrumb) -->
          <template v-if="isCredit">
            <v-icon small class="mr-2">mdi-credit-card</v-icon>
            <router-link :to="{ name: 'receiver-credit-list' }">Credits</router-link>
            <div class="separator">/</div>
            <div class="active-item">Order {{ order.thirdparty_order_number }} <span class="ml-1">(Credit Memo)</span></div>
          </template>
          <template v-else>
            <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
            <router-link :to="{ name: 'receiver-order-list' }">Orders</router-link>
            <div class="separator">/</div>
            <div class="active-item">Order {{ order.thirdparty_order_number }}</div>
          </template>
        </v-col>
        <v-col sm="4" align="right">
          <!-- (download invoice) -->
          <order-invoice-download v-if="allowDownload && order && $root.isOrderInvoiceGuaranteed(order)" :order="order" />
        </v-col>
      </v-row>

      <!-- Order Info Header -->
      <order-info-header :order="order" />

      <!-- Page Navigation -->
      <v-tabs fixed-tabs show-arrows class="mt-4 page-navigation" v-model="activeTab">
        <v-tab @click="$root.goTo('receiver-order-info-summary')">Summary</v-tab>
        <v-tab @click="$root.goTo('receiver-order-info-attachment-docs')">Attachment Docs</v-tab>
        <v-tab @click="$root.goTo('receiver-order-info-tracking-history')" v-if="!isCredit">Tracking History</v-tab>
        <v-tab @click="$root.goTo('receiver-order-info-messages')" v-if="!isCredit">
          <v-icon style="font-size:18px;" class="pr-3 pt-1">mdi-message-text-outline</v-icon>
          Messages
        </v-tab>
      </v-tabs>

      <!-- Page View -->
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>

    </v-container>

  </v-container>

</template>

<script>
import OrderInvoiceDownload from '@/components/orders/OrderInvoiceDownload'
import OrderInfoHeader from '@/components/orders/OrderInfoHeader'

export default {
  name: 'ReceiverOrderInfoRootPage',

  components: {
    OrderInvoiceDownload,
    OrderInfoHeader
  },

  props: {
    orderId: {
      required: true
    }
  },

  data () {
    return {
      activeTab: 0,
      isDataLoading: false,
      dataLoadingError: null,
      order: null,
      route: null
    }
  },

  computed: {
    isCredit () {
      return this.order.is_credit
    },
    allowDownload () {
      return this.order.order_status !== 'BEING_SCHEDULED'
    }
  },

  async beforeMount () {
    // Load the order data
    await this.loadData()

    // Set active tab
    this.setActiveTab()
  },

  beforeDestroy () {
    this.order = null
  },

  methods: {
    setActiveTab () {
      switch (this.$route.name) {
        case 'receiver-order-info-overview': this.activeTab = 0; break
        case 'receiver-order-info-attachment-docs': this.activeTab = 1; break
        case 'receiver-order-info-tracking-history': this.activeTab = 2; break
        case 'receiver-order-info-messages': this.activeTab = 3; break
        default: this.activeTab = 0
      }
    },

    // Load order and route data
    async loadData () {
      this.isDataLoading = true

      try {
        // Load order
        this.order = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: `receiver-order/${this.orderId}`,
          opts: {
            params: { with: 'order_details' }
          }
        })
      } catch (err) {
        console.log('Error loading order and route data =>', err)
        this.dataLoadingError = err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style>
</style>
